module.exports = __webpack_public_path__ + "img/sms-subject.d60bfbc8.svg";